var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardTech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8F08CFF6-ECB3-4BCA-A61C-434CC99883C6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact-us",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-us---General",
    transform: "translate(-270.000000, -757.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(250.000000, 737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card_tech",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.062541, 16.895549)",
    stroke: "#FFFFFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8122508,11.7083232 C7.57908374,11.7083232 4.95808919,9.08732861 4.95808919,5.85416158 C4.95808919,2.62099455 7.57908374,0 10.8122508,0 C14.0454178,0 16.6664203,2.62099455 16.6664203,5.85416158 C16.6664203,9.08732861 14.0454178,11.7083232 10.8122508,11.7083232 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6250022,25.1873016 C21.6250022,20.3331351 16.7916636,16.3747152 10.8124971,16.3747152 C4.83333071,16.3747152 0,20.3123018 0,25.1873016",
    id: "Vector",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.9583333,45.8333333 C13.0208333,45.8333333 4.16666667,36.9791667 4.16666667,26.0416667 C4.16666667,15.1041667 13.0208333,6.25 23.9583333,6.25 C26.6874999,6.25 29.2916683,6.79164634 31.6666667,7.79164632 C31.3958349,8.62497967 31.25,9.5 31.25,10.4166667 C31.25,11.9791667 31.6875038,13.4583282 32.4583371,14.7083282 C32.8750038,15.4166616 33.416667,16.062439 34.041667,16.6041056 C35.5000003,17.9374389 37.4375001,18.75 39.5833333,18.75 C40.5,18.75 41.375,18.6041209 42.1875,18.3124542 C43.1875,20.6874542 43.75,23.3125001 43.75,26.0416667 C43.75,36.9791667 34.8958333,45.8333333 23.9583333,45.8333333 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,0 L50,50 L0,50 L0,0 L50,0 Z",
    id: "Vector",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.250000, 2.080000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4583613,12.6249949 C15.0208613,13.3749949 14.4583435,14.0416667 13.8125102,14.5833333 C12.3541769,15.8958333 10.4375,16.6666667 8.33333333,16.6666667 C5.29166659,16.6666667 2.64580535,15.0416615 1.20830536,12.6249949 C0.437472016,11.3749949 0,9.89583333 0,8.33333333 C0,5.70833335 1.2083333,3.35417688 3.125,1.83334351 C4.5625,0.687510148 6.375,0 8.33333333,0 C12.9375001,0 16.6666667,3.72916659 16.6666667,8.33333333 C16.6666667,9.89583333 16.2291947,11.3749949 15.4583613,12.6249949 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08321126,8.33333333 L7.14569092,10.395813 L11.5832011,6.29170736",
    id: "Vector"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTech);
export default __webpack_public_path__ + "static/media/card_tech.19a3c10bcac5f506ea52429f18038531.svg";
export { ForwardRef as ReactComponent };